import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { USERS_PATHS } from './users';

import { ServiceFunctionsComponent } from './service-functions/service-functions.component';
import { UsersComponent } from './users/users.component';
import { UsersCreateComponent } from './users-create/users-create.component';
import { UsersEditComponent } from './users-edit/users-edit.component';

import { AuthGuard } from '../auth/auth.guard.service';

const routes: Routes = [
  {
    path: USERS_PATHS.service_functions,
    component: ServiceFunctionsComponent,
    canActivate: [AuthGuard],
    data: {
      animation: 'CollaboratorsServiceFunctionPage',
      permission: 'service_function.get',
    },
  },
  {
    path: USERS_PATHS.users,
    component: UsersComponent,
    canActivate: [AuthGuard],
    data: { animation: 'CollaboratorsPage', permission: 'employee.get' },
  },
  {
    path: USERS_PATHS.users_create,
    component: UsersCreateComponent,
    canActivate: [AuthGuard],
    data: {
      animation: 'CollaboratorsCreatePage',
      permission: 'employee.add',
    },
  },
  {
    path: USERS_PATHS.users_edit,
    component: UsersEditComponent,
    canActivate: [AuthGuard],
    data: {
      animation: 'CollaboratorsEditPage',
      permission: 'employee.edit',
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class UsersRoutingModule {}
